import { SubmitHandler, useForm, FieldError } from 'react-hook-form';
import { GetIdentityTypes } from '../../../../services';
import axios, { AxiosError } from 'axios'
import ChileanRutify from 'chilean-rutify';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { updatePersonalDataCarrera } from '../../../../store/slices/userDataFormSlice';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';
import { addLocale } from 'primereact/api';
import { format, isBefore } from 'date-fns';
import { Calendar } from 'primereact/calendar';
import "intl-tel-input/build/css/intlTelInput.css";
import IntlTelInput from 'intl-tel-input/reactWithUtils';
import intlTelInput from 'intl-tel-input';
import { ProgressSpinner } from 'primereact/progressspinner';

interface PhoneValidationErrors {
  phone?: FieldError;
}

type PropsFormUser = {
  stepsLength: number;
  currentStep: number;
  setCurrentStep: (value: number) => void;
  setComplete: (value: boolean) => void;
  registerId: string;
  token: string;
  dataUser: any;
};

const errorMap = ["Número no válido", "Código de país no válido", "Número muy corto", "Número muy largo", "Número no válido"];

export const FormPersonalData = (props: PropsFormUser) => {

  const ref = useRef(null);
  const refCompanyPhone = useRef(null);

  const [isValid, setIsValid] = useState<boolean>(false);
  const [errorCode, setErrorCode] = useState<number | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  const [localPhone, setLocalPhone] = useState("");
  const [localPhoneCode, setLocalPhoneCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [isBilling, setIsBilling] = useState(false);

  const [billingPhone, setBillingPhone] = useState('');
  const [billingPhoneCode, setBillingPhoneCode] = useState('');
  const [isValidBillingPhone, setIsValidBillingPhone] = useState(false);
  const [billingPhoneErrorCode, setBillingPhoneErrorCode] = useState<number | null>(null);
  const [billingPhoneNotice, setBillingPhoneNotice] = useState<string | null>(null);

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: [
      'domingo',
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado'
    ],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre'
    ],
    monthNamesShort: [
      'ene',
      'feb',
      'mar',
      'abr',
      'may',
      'jun',
      'jul',
      'ago',
      'sep',
      'oct',
      'nov',
      'dic'
    ],
    today: 'Hoy',
    clear: 'Limpiar'
  });
  const [selectedIdentityType, setSelectedIdentityType] = useState('');
  const [birthday, setBirthday] = useState<string | Date>(
    new Date().toLocaleDateString()
  );
  const { indentityTypes } = GetIdentityTypes();
  const [inputRut, setInputRut] = useState('');
  const [inputCompanyRut, setInputCompanyRut] = useState('');
  const [listCountries, setListCountries] = useState([]);
  const [countrySelected, setCountrySelected] = useState<any>(null);
  const [nationalitySelected, setNationalitySelected] = useState<any>(null);
  const [selectedGender, setSelectedGender] = useState('');
  const user = useSelector((state: RootState) => state.user);

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: user.user?.name ?? '',
      identity_type_id: user.user?.identity_type?.id ?? '',
      address: user.user?.address ?? '',
      lastname: user.user?.lastname ?? '',
      birthday: user.user?.birthday ?? '',
      dni: user.user?.dni ?? '',
      phone: user.user?.phone ?? '',
      phone_code: user.user?.phone_code ?? '',
      email: user.user?.email ?? '',
      country_id: user.user?.country_id ?? null,
      nationality: user.user?.nationality_id ?? null,
      gender: user.user?.gender ?? '',
      city: user.user?.city ?? '',
      billing_address: user.billing?.address ?? '',
      business_line: user.billing?.business_line ?? '',
      business_name: user.billing?.business_name ?? '',
      billing_dni: user.billing?.dni ?? '',
      document_type_id: user.billing?.document_type_id ?? null,
      billing_email: user.billing?.email ?? '',
      billing_phone: user.billing?.phone ?? null,
      billing_phone_code: user.billing?.phone_code ?? null,
    }
  });

  const phoneIsoCode = intlTelInput.getCountryData().find((e) => e.dialCode == user.user.phone_code)?.iso2 || null;

  const billingPhoneIsoCode = user.billing?.phone_code 
  ? intlTelInput.getCountryData().find((e) => e.dialCode == user.billing.phone_code)?.iso2 || null
  : 'cl';

  useEffect(() => {

    if (isValid) {

      clearErrors()

      if (getValues("phone") !== localPhone) {
        setValue("phone", localPhone);
      }
      if (getValues("phone_code") !== localPhoneCode) {
        setValue("phone_code", localPhoneCode);
      }

    } else {
      const errorMessage = errorMap[errorCode || 0] || "Invalid number";

      setNotice(`${errorMessage}`);

      setError("phone", {
        type: "manual",
        message: "Número no válido",
      });

    }

  }, [localPhone]);

  useEffect(() => {

  if (billingPhone && isBilling) { // Solo validar si hay teléfono y facturación está activa
    if (isValidBillingPhone) {
      clearErrors('billing_phone');

      if (getValues("billing_phone") !== billingPhone) {
        setValue("billing_phone", billingPhone);
      }
      if (getValues("billing_phone_code") !== billingPhoneCode) {
        setValue("billing_phone_code", billingPhoneCode);
      }
    } else {
      const errorMessage = errorMap[billingPhoneErrorCode || 0] || "Número no válido";
      setBillingPhoneNotice(errorMessage);

      setError("billing_phone", {
        type: "manual",
        message: errorMessage,
      });
    }
  }
}, [billingPhone, isValidBillingPhone, billingPhoneErrorCode, isBilling]);

  const newPhone = user.user?.phone ? user.user?.phone : '';

  useEffect(() => {

    if (user && user.user) {
      if (user.user.birthday) {
        const birthday = user.user.birthday.split('-');
        setBirthday(
          new Date(
            Number(birthday[0]),
            Number(birthday[1]) - 1,
            Number(birthday[2])
          )
        );
      } else {
        setBirthday(format(new Date(), 'yyyy-MM-dd'));
      }
    }
    if (user.user?.dni) setInputRut(user.user?.dni);
    const userIdentityTypeId = user.user?.identity_type?.id ?? '';
    setSelectedIdentityType(userIdentityTypeId.toString());
    if (user.user?.gender) setSelectedGender(user.user.gender);
    getCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user.billing && user.billing.document_type_id == 2) {
      setIsBilling(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const getCountries = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_BACKEND}/countries`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token_user_latam')}`
          }
        }
      )
      .then((response: any) => {
        setListCountries(response.data);
        const findCountrie = response.data.find((data: any) => {
          if (user.user && user.user.country_id) {
            if (data.id === user.user.country_id) return data;
          }
          return null;
        });

        if (findCountrie) {
          setCountrySelected(findCountrie);
        }

        const findNationality = response.data.find((data: any) => {
          if (user.user && user.user.nationality_id) {
            if (data.id === user.user.nationality_id) return data;
          }
          return null;
        });

        if (findNationality) {
          setNationalitySelected(findNationality);
        }
      })
      .catch((error: AxiosError) => console.log('Error Countries =>', error));
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    setLoader(true);

    if (selectedIdentityType) data.identity_type_id = selectedIdentityType;
    if (countrySelected) data.country_id = countrySelected.id;
    if (selectedGender) data.gender = selectedGender;

    // Asegurarse de que nationality sea string
    if (data.nationality) {
      data.nationality = String(data.nationality);
    }

    await axios
      .post(
        `${process.env.REACT_APP_API_BACKEND}/register_form/personal_info`,
        { register_id: props.registerId, ...data },
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${props.token}`
          }
        }
      )
      .then((response) => {
        dispatch(updatePersonalDataCarrera(data));
        axios
          .post(
            `${process.env.REACT_APP_API_BACKEND
            }/registers/${localStorage.getItem('register_id')}/step`,
            {
              step: props.currentStep + 1
            },
            {
              headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${localStorage.getItem('token_user_latam')}`
              }
            }
          )
          .then((response) => {
            props.setCurrentStep(props.currentStep + 1);
          })
          .catch((error: AxiosError) => console.log('Error Aval =>', error));
      })
      .catch((error: AxiosError) =>
        console.log('Error fetchDataUser =>', error)
      )
    // .finally(() => {
    //   setLoader(false);
    // });
  };

  const RenderRequiredField = ({ text = 'Campo Requerido' }) => {
    return <span className='font-light text-red-500'>{text}</span>;
  };

  const handleIdentityTypeChange = (event: any) => {
    setSelectedIdentityType(event.target.value);
    setInputRut('');
  };

  const prevStep = () => {
    props.setCurrentStep(props.currentStep - 1);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='w-full max-w-6xl mx-auto'>

      <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-6">Información personal</h3>

        <div className='grid gap-6 sm:grid-cols-1 md:grid-cols-2'>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Nombre*</label>
            <input
              type='text'
              className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors"
              {...register('name', { required: true, maxLength: 20 })}
            />
            {errors.name?.type === 'required' && <RenderRequiredField />}
            {errors.name?.type === 'maxLength' && (
              <RenderRequiredField text='Máximo de caracteres 20' />
            )}
          </div>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Apellidos*</label>
            <input
              type='text'
              className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors"
              {...register('lastname', { required: true, maxLength: 30 })}
            />
            {errors.name?.type === 'required' && <RenderRequiredField />}
            {errors.name?.type === 'maxLength' && (
              <RenderRequiredField text='Máximo de caracteres 30' />
            )}
          </div>
        </div>

        <div className='grid gap-6 grid-cols-1 md:grid-cols-2 mt-6'>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Tipo de Identificación*</label>
            <select
              className='w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors'
            // onChange={(e) => {
            //   setValue('identity_type_id', Number(e.target.value));
            // }}
            value={selectedIdentityType}
            onChange={handleIdentityTypeChange}
          >
            <option value='' disabled>
              Seleccionar
            </option>
            {indentityTypes &&
              indentityTypes.map((niv, index) => (
                <option key={index} value={niv.id}>
                  {niv.description}
                </option>
              ))}
          </select>
        </div>
        <div className='flex flex-col'>
          <label className="block text-sm font-medium text-gray-900 mb-2">Número de identificación*</label>
          <input
            value={inputRut}
            className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
            disabled={!selectedIdentityType} // Input deshabilitado si no hay un tipo seleccionado
            onKeyDown={(input: any) => {
              if (selectedIdentityType === '1' || selectedIdentityType === '') {
                const esNumero =
                  (input.keyCode >= 48 && input.keyCode <= 57) || // Teclado numérico
                  (input.keyCode >= 96 && input.keyCode <= 105) ||
                  input.keyCode === 75 || // Tecla 'K'
                  input.keyCode === 8; // Tecla de retroceso

                if (!esNumero) {
                  input.preventDefault(); // Bloquea el resto de los caracteres
                }
              } else {
                const key = input.key;
                // Expresión regular para caracteres especiales
                const specialCharsRegex = /[!@#$%^&*(),.?":{}¨¨|<>/+~´´áéíóúÁÉÍÓÚ]/;
                const isValidChar =
                  (key >= '0' && key <= '9') || // Números
                  (key >= 'a' && key <= 'z') || // Letras minúsculas
                  (key >= 'A' && key <= 'Z') || // Letras mayúsculas
                  key === '-' || key === '0'; // Guion y tecla 0

                if (!isValidChar || specialCharsRegex.test(key)) {
                  input.preventDefault(); // Bloquea caracteres no permitidos
                }
              }
            }}
            {...register('dni', {
              required: true,
              onChange: (e) => {
                if (selectedIdentityType === '1' || selectedIdentityType === '') {
                  if (e.target.value !== '-') {
                    setInputRut(String(ChileanRutify.formatRut(e.target.value)));
                    setValue(
                      'dni',
                      String(ChileanRutify.formatRut(e.target.value))
                    );
                  } else {
                    setInputRut('');
                  }
                } else {
                  setInputRut(e.target.value);
                  setValue('dni', e.target.value);
                }
              },
              // Validar solo si selectedIdentityType es '1'
              validate: (v) => {
                if (selectedIdentityType === '1') {
                  return ChileanRutify.validRut(v); // Solo validar RUT si el tipo es '1'
                }
                return true; // Si no es RUT, devolver true para que pase sin validación
              }
            })}
          />
          {errors.dni?.type === 'required' && (
            <span className='text-red-500 text-sm font-light'>
              Rut requerido
            </span>
          )}
          {errors.dni?.type === 'validate' && selectedIdentityType === '1' && (
            <span className='text-red-500 text-sm font-light'>
              Rut invalido
            </span>
          )}
        </div>
        </div>
        <div className='grid gap-6 sm:grid-cols-1 md:grid-cols-2 mt-6'>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Correo electrónico*</label>
            <input
              type='email'
              className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
              {...register('email', {
                required: true,
                pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/
              })}
              disabled
            />
            {errors.email?.type === 'required' && <RenderRequiredField />}
            {errors.email?.type === 'pattern' && (
              <span className='text-red-500 text-sm font-light'>
                Formato de correo no válido
              </span>
            )}
          </div>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Número teléfonico*</label>
            <IntlTelInput
              ref={ref}
              initialValue={''}
              onChangeNumber={() => {
                const phoneNumber = ref.current?.getInstance().telInput.value;
                const countryCode = ref.current?.getInstance().selectedCountryData.dialCode;

                setLocalPhone(phoneNumber || "");
                setLocalPhoneCode(countryCode || "");

              }}
              onChangeValidity={setIsValid}
              onChangeErrorCode={setErrorCode}
              inputProps={{ required: true }}
              initOptions={{
                initialCountry: phoneIsoCode || 'cl',
                separateDialCode: false,
              }}
            />
            {errors.phone?.type === 'required' && <RenderRequiredField />}
            {errors.phone?.type === 'maxLength' && (
              <span className='text-red-500 text-sm font-light'>
                Debe tener menos de 15 digitos
              </span>
            )}
            {errors.phone?.type === 'minLength' && (
              <span className='text-red-500 text-sm font-light'>
                Debe tener más de 5 digitos
              </span>
            )}

            {errors.phone?.type === 'manual' && (
              <span className='text-red-500 text-sm font-light'>
                {notice}
              </span>
            )}
          </div>
        </div>

        <div className='grid gap-6 sm:grid-cols-1 md:grid-cols-2 mt-6'>
          <div className="flex flex-col">
            <label className="block text-sm font-medium text-gray-900 mb-2">Fecha de nacimiento*</label>
            <Calendar
              className="w-full"
              dateFormat="dd-mm-yy"
              locale="es"
              placeholder="dd-mm-yyyy"
              value={birthday}
              {...register('birthday', {
                required: true,
                onChange: (evt) => {
                  setBirthday(evt.value)
                  if (evt.value) {
                    setValue(
                      'birthday',
                      String(format(new Date(evt.target.value), 'yyyy-MM-dd'))
                    );
                  } else {
                    setValue('birthday', '');
                  }
                },
                validate: (evt: any) => {
                  const inputDate = evt.split('-');
                  const myBirthday = new Date(
                    inputDate[0],
                    inputDate[1],
                    inputDate[2]
                  );
                  const today = new Date();
                  if (isBefore(myBirthday, today)) {
                    return true;
                  }
                  return false;
                }
              })}
            />
            {errors.birthday && <RenderRequiredField />}
            {errors.birthday?.type === 'validate' && (
              <span className="font-light text-red-500 text-sm">
                Fecha de nacimiento debe ser menor a la de hoy
              </span>
            )}
          </div>

          <div className="flex flex-col">
            <label className="block text-sm font-medium text-gray-900 mb-2">Dirección*</label>
            <input
              type="text"
              className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors"
              {...register('address', { required: true })}
            />
            {errors.address && <RenderRequiredField />}
          </div>
        </div>
      </div>

      <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-6">Información de residencia</h3>

        <div className='grid gap-6 sm:grid-cols-1 md:grid-cols-2'>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Ciudad de Residencia*</label>
            <input
              type='text'
              className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors"
              {...register('city', { required: true })}
            />
            {errors.city && <RenderRequiredField />}
          </div>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">País de residencia*</label>
            <Dropdown
              value={countrySelected}
              options={listCountries}
              optionLabel='description'
              filter
              className='dropdown-form w-full'
              {...register('country_id', {
                required: true,
                onChange(evt: DropdownChangeParams) {
                  if (evt.value.id) {
                    setCountrySelected(evt.value);
                    setValue('country_id', Number(evt.value.id));
                  }
                }
              })}
            />
            {errors.country_id?.type === 'required' && <RenderRequiredField />}
          </div>
        </div>

        <div className='grid gap-6 sm:grid-cols-1 md:grid-cols-2 mt-6'>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Nacionalidad*</label>
            <Dropdown
              value={nationalitySelected}
              options={listCountries}
              optionLabel='description'
              filter
              className='dropdown-form w-full'
              {...register('nationality', {
                required: true,
                onChange(evt: DropdownChangeParams) {
                  if (evt.value.description) {
                    setNationalitySelected(evt.value);
                    setValue('nationality', evt.value.description);
                  }
                }
              })}
            />
            {errors.nationality?.type === 'required' && <RenderRequiredField />}
          </div>
          <div className='flex flex-col'>
            <label className="block text-sm font-medium text-gray-900 mb-2">Género*</label>
            <select
              className='w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors'
              value={selectedGender}
              {...register('gender', {
                required: true,
                onChange: (e) => {
                  setSelectedGender(e.target.value);
                  setValue('gender', e.target.value);
                }
              })}
            >
              <option value='' disabled>
                Seleccionar
              </option>
              <option value='Masculino'>Masculino</option>
              <option value='Femenino'>Femenino</option>
              <option value='No binario'>No binario</option>
              <option value='Otro'>Otro</option>
            </select>
            {errors.gender?.type === 'required' && <RenderRequiredField />}
          </div>
        </div>
      </div>

      <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-6">Programa</h3>
        <div className='flex flex-col'>
          <label className="block text-sm font-medium text-gray-900 mb-2">Programa en el que te matriculas</label>
          <input
            type='text'
            className="w-full border-2 border-gray-300 rounded-lg p-3 bg-gray-100 text-gray-900 cursor-not-allowed"
            placeholder={user.variant_application ? (user.career?.variant_friendly_name ?? '') : (user.career?.friendly_name ?? '')}
            disabled={true}
          />
        </div>
      </div>

      {isBilling && (
        <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-6 mb-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">Datos de facturación</h3>

          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2">
            <div className="flex flex-col">
              <label className="block text-sm font-medium text-gray-900 mb-2">Razón Social*</label>
              <input
                type="text"
                className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={!isBilling}
                {...register('business_name', {
                  required: isBilling ?? true
                })}
              />
              {errors.business_name && <RenderRequiredField />}
            </div>
            <div className="flex flex-col">
              <label className="block text-sm font-medium text-gray-900 mb-2">Rut Empresa*</label>
              <input
                type="text"
                className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={!isBilling}
                value={inputCompanyRut}
                onKeyDown={(input: any) => {
                  const esNumero =
                    (input.keyCode >= 48 && input.keyCode <= 57) ||
                    (input.keyCode >= 96 && input.keyCode <= 105) ||
                    input.keyCode === 8;

                  if (!esNumero) {
                    input.preventDefault();
                  }
                }}
                {...register('billing_dni', {
                  required: isBilling ?? true,
                  onChange: (e) => {
                    if (e.target.value !== '-' && e.target.value !== '') {
                      setInputCompanyRut(
                        String(ChileanRutify.formatRut(e.target.value))
                      );
                      setValue(
                        'billing_dni',
                        String(ChileanRutify.formatRut(e.target.value))
                      );
                    } else {
                      setInputCompanyRut('-');
                    }
                  },
                  validate: (v: any) => {
                    return ChileanRutify.validRut(v);
                  }
                })}
              />
              {errors.billing_dni?.type === 'required' && (
                <span className="text-red-500 text-sm font-light">
                  Rut requerido
                </span>
              )}
              {errors.billing_dni?.type === 'validate' && (
                <span className="text-red-500 text-sm font-light">
                  Rut invalido
                </span>
              )}
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 mt-6">
            <div className="flex flex-col">
              <label className="block text-sm font-medium text-gray-900 mb-2">Giro*</label>
              <input
                type="text"
                className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={!isBilling}
                {...register('business_line', {
                  required: isBilling ?? true
                })}
              />
              {errors.business_line && <RenderRequiredField />}
            </div>
            <div className="flex flex-col">
              <label className="block text-sm font-medium text-gray-900 mb-2">Dirección de facturación</label>
              <input
                type="text"
                className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={!isBilling}
                {...register('billing_address', { required: isBilling ?? true })}
              />
              {errors.billing_address && <RenderRequiredField />}
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 mt-6">
            <div className="flex flex-col">
              <label className="block text-sm font-medium text-gray-900 mb-2">Email Empresa*</label>
              <input
                type="email"
                className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={!isBilling}
                {...register('billing_email', { required: isBilling ?? true })}
              />
              {errors.billing_email && <RenderRequiredField />}
            </div>

            <div className="flex flex-col">
              <label className="block text-sm font-medium text-gray-900 mb-2">Teléfono Empresa*</label>
              <IntlTelInput
                ref={refCompanyPhone}
                initialValue={billingPhone}
                disabled={!isBilling}
                onChangeNumber={() => {
                  if (isBilling && refCompanyPhone.current) {
                    const phoneNumber = refCompanyPhone.current.getInstance().telInput.value;
                    const countryCode = refCompanyPhone.current.getInstance().selectedCountryData.dialCode;

                    setBillingPhone(phoneNumber || "");
                    setBillingPhoneCode(countryCode || "");
                  }
                }}
                onChangeValidity={setIsValidBillingPhone}
                onChangeErrorCode={setBillingPhoneErrorCode}
                inputProps={{
                  required: isBilling,
                  disabled: !isBilling
                }}
                initOptions={{
                  initialCountry: billingPhoneIsoCode || 'cl',
                  separateDialCode: false,
                }}
              />

              {errors.billing_phone?.type === 'required' && <RenderRequiredField />}
              {errors.billing_phone?.type === 'manual' && (
                <span className='text-red-500 text-sm font-light'>
                  {billingPhoneNotice}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      <div className='flex justify-between items-center pt-6 border-t border-gray-300'>
        <button className="btn-prev" type="button" onClick={() => prevStep()}>
          Atrás
        </button>
        <button
          className='btn relative inline-flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed min-w-[140px]'
          type='submit'
          disabled={loader}
        >
          {loader ? (
            <ProgressSpinner
              style={{ width: '25px', height: '25px' }}
              strokeWidth="5"
              fill="#9CA3AF"
              animationDuration="1.5s"
            />
          ) : (
            "Continuar"
          )}
        </button>
      </div>
    </form>
  );
};
